export default __webpack_public_path__ + "static/media/red_ficsmas_ornament.3f748959.png";